import { useStateUpdater } from "@/helpers/useStateUpdater";
import { defineStore } from "pinia";
import { FinancesService } from "@core/services/webmaster/finances/FinancesService";
import { FinanceTypeEnum } from "@core/store/types/webmaster/finances/modal/enum/financeTypeEnum";
import momentjs from "moment";
import { FinanceOutTransactionType } from "@core/store/types/webmaster/finances/modal/enum/financeOutTransactionType";
import moment from "moment/moment";
import store from "@/store";
import { FinanceDayEnum } from "@core/store/types/webmaster/finances/modal/enum/financeDayEnum";
import vuexStore from "@/store";
import { FinancesAutoPayments } from "@core/store/types/webmaster/finances/modal/financeAutoPayments";

export const useAutoPayments = defineStore("webmaster/autoPaymentsStore", {
  state: (): FinancesAutoPayments => ({
    data: null,
    options: {
      daysOfWeek: [FinanceDayEnum.TUESDAY, FinanceDayEnum.FRIDAY],
      type: FinanceTypeEnum.DAILY,
      outTransactionType: FinanceOutTransactionType.SUM,
      datepickerDates: null,
      requisiteId: null,
      isEdit: false,
      time: 840,
      sum: null
    }
  }),

  getters: {
    balance: () => vuexStore.state.balance.balance,
    availableCurrencies: () => store.state.auth.availableCurrencies
  },

  actions: {
    async ACTION_AUTO_OUT_TRANSACTION () {
      let { time, type, daysOfWeek, datepickerDates, outTransactionType, sum, requisiteId, isEdit, id } = this.options;
      const isDaily = type === FinanceTypeEnum.DAILY;
      const isWeekly = type === FinanceTypeEnum.WEEKLY;
      const daysOfMonth = !(isWeekly || isDaily) ? datepickerDates?.map(date => +momentjs(date).format("D")) : null;
      const hasTime = outTransactionType === FinanceOutTransactionType.TIME;

      // @ts-ignore
      time = hasTime ? moment().endOf("day").add(time, "minutes").toDate() : null;
      // @ts-ignore
      daysOfWeek = isWeekly ? daysOfWeek : null;
      type = hasTime ? FinanceTypeEnum.DAILY : null;
      sum = hasTime ? null : sum;

      const input = { time, daysOfMonth, isDaily, daysOfWeek, outTransactionType, sum, ...!isEdit && { requisiteId } };

      if (isEdit) {
        const data = await FinancesService.editAutoOutTransaction(id, input);
        useStateUpdater(useAutoPayments).LOCAL_UPDATE({ items: [data] });
      } else {
        const data = await FinancesService.createAutoOutTransaction(input);
        useStateUpdater(useAutoPayments).LOCAL_ADD({ items: [data] });
      }
    },

    async GET_AUTO_OUT_TRANSACTIONS (): Promise<void> {
      const items = await FinancesService.getAutoOutTransactions();
      this.data = { items, count: items.length };
    },

    async DELETE_AUTO_OUT_TRANSACTIONS (id: string): Promise<void> {
      const item = await FinancesService.deleteAutoOutTransactions(id);
      useStateUpdater(useAutoPayments).LOCAL_DELETE({ items: [item] });
    }
  }
});